import { ListReducer, mergeEntities } from '../../store';
import { UserApi } from '../../api-typings/users/users';
import { transformUserBalances } from '../../user/user.reducer';

export const navigationUserBalancesReducer: ListReducer<
  'navigationUserBalances'
> = (state = {}, action) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (
        action.payload &&
        action.payload.ref.path[0] === 'navigationUserBalances'
      ) {
        const ref = action.payload.ref;
        const data = <UserApi>action.payload.data;
        return mergeEntities<'navigationUserBalances'>(
          state,
          transformUserBalances(data),
          ref,
        );
      }
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/datastore/navigation/user-balances/user-balances.reducer.ts